
export default {
  people: [],
  person: [],
  addresses: []
}
